import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import Helmet from 'react-helmet';
import axios from 'axios';
import { sortBy } from 'lodash';

import translate from '../../../utils/translate';
import baseUrl from '../../../utils/baseUrl';
import { accountRoute } from '../../../routes';

import connect from '../../../utils/connect';

import BlockContent from '../../account/block/content';

import JuryNav from './juryNav';
import JuryEntry from './juryEntry';
import JurySticky from './jurySticky';

import Splitter from '../block/splitter';
import Spinner from '../../svg/spinner';

import Form from '../../form/form';
import InputText from '../../form/input/text';
import InputSwitch from '../../form/input/switch';
import InputTextarea from '../../form/input/textarea';
import InputSubmit from '../../form/input/submit';
import InputSelect from '../../form/select/select';

import { DateFormatter } from '../../../utils/date';

import qs from 'qs';

// import { AccountJuryOther, AccountJuryMediaTitle} from './other';
// import { caseFilterResponsive } from './juryHelper';

const API_URL = baseUrl + '/api/account/jury/tcea';

const MODE_CANDIDATES = 1;
const MODE_WINNERS = 2;

class AccountJuryTCEA extends Component {

	constructor(props) {
		super();

		this.mounted = true;

		this.state = {
			waiting: true,
			caseWait: false,
			mode: MODE_CANDIDATES,
			candidates: [],
			winners: [],
			linkAbout: false,
		};
	}

	componentWillReceiveProps(nextProps) {}

	componentWillMount() {
		this.fetchData();
	}

	fetchData(state) {
		if (this.mounted) {
			this.setState({
				...this.state,
				...state,
				caseWait: true,
			});
		}

		axios.all([
			axios.get(API_URL),
			axios.get(API_URL + '/winners'),
		])
		.then(axios.spread((candRes, winRes) => {
			let data = {
				candidates: [],
				winners: [],
				...this.applyData(MODE_WINNERS, winRes.data),
				...this.applyData(MODE_CANDIDATES, candRes.data),
			};

			if (this.mounted) {
				this.setState({
					...this.state,
					...state,
					waiting: false,
					caseWait: false,
					...data,
				});
			}
		}))
		.catch(() => {
			if (this.mounted) {
				this.setState({
					...this.state,
					...state,
					waiting: false,
					caseWait: false,
				});
			}
		});
	}

	applyData(mode, data) {
		const newData = {};

		if (mode === MODE_CANDIDATES) {
			if (data.cases) {
				newData.candidates = data.cases;
			}
		}

		if (mode === MODE_WINNERS) {
			if (data.cases) {
				newData.winners = sortBy(data.cases, 'week');
			}
		}

		if (data.linkAbout) {
			newData.linkAbout = data.linkAbout;
		}

		if (data.nextDate) {
			newData.nextDate = data.nextDate;
		}

		return newData;
	}

	updateData(mode, state) {
		if (mode === MODE_CANDIDATES) {
			this.fetchData(state);
		} else {
			const API = mode !== MODE_WINNERS ? API_URL : `${API_URL}/winners`;

			axios.get(API)
			.then((res) => {
				this.setState({
					...this.state,
					...state,
					...this.applyData(mode, res.data),
					caseWait: false,
					waiting: false,
				});
			})
			.catch(() => {
				this.setState({
					...this.state,
					...state,
					caseWait: false,
					waiting: false,
				});
			});
		}
	}

	componentWillUnmount() {
		this.mounted = false;
	}

	render() {
		let inactiveTabClass = 'account-jury__tcea__tabs__tab';
		let activeTabClass = 'account-jury__tcea__tabs__tab account-jury__tcea__tabs__tab--active';

		if (this.state.waiting) {
			return this.renderWaiting();
		}

		let { linkAbout, candidates, winners, nextDate } = this.state;
		let cases = (this.state.mode === MODE_CANDIDATES) ? candidates : winners;


		return (
			<div className=''>
				<div className='account-block-content'>
					<div className='span14 account-block-content__aside account-jury__head'>
						{candidates.length} projects up for voting
					</div>

					<div className='cf'></div>

					<JurySticky browser={this.props.browser} className='account-jury__sticky'>
						<div className='span5 span5-tablet span14-mobile account-jury__col1 account-jury__subhead account-jury__subhead--first'>
							<JuryNav users={this.props.users} />
						</div>

						<div className='hide-tablet hide-mobile account-jury__col2'></div>

						<div className='span9-tablet span14-mobile account-jury__col3 hide-mobile account-jury__subhead'></div>
						<div className='cf'></div>
					</JurySticky>
				</div>

				<div className='account-block-content account-jury__infoblock'>
					<div className='span5 span5-tablet hide-mobile account-jury__col1'>
						<div className='account-jury__col1__about'>About</div>
					</div>
					<div className='span9-tablet span14-mobile account-jury__col2 account-jury__scorecard__intro'>
						<p dangerouslySetInnerHTML={{ __html: translate('account/jury/tcea') }}></p>
					</div>

					<div className='span0 span5-tablet hide-mobile account-jury__col1'></div>
					<div className='span9-tablet span14-mobile account-jury__col3'>
						{(!!linkAbout) && (
							<div>
								<p className='account-jury__linklist-head'>Read more</p>
								<ol className='account-jury__linklist'>
									<li className='account-jury__linklist__item'><Link to={linkAbout.url}>{linkAbout.text}</Link></li>
								</ol>
							</div>
						)}
					</div>

					<div className='cf'></div>
				</div>

				<div className='account-jury__tcea__tabs'>
					<a href='#' className={this.state.mode === MODE_CANDIDATES ? activeTabClass : inactiveTabClass} onClick={(e) => this.switchMode(e, MODE_CANDIDATES)}>Candidates</a>
					<a href='#' className={this.state.mode === MODE_WINNERS ? activeTabClass : inactiveTabClass} onClick={(e) => this.switchMode(e, MODE_WINNERS)}>Winners</a>
				</div>

				<Splitter />

				{(!!this.state.caseWait) && this.renderWaiting()}

				{(!this.state.caseWait) && (cases.map((item, i) =>
					<JuryEntry
						key={item.id}
						item={item}
						browser={this.props.browser}
						dispatch={this.props.dispatch}
						component={this.state.mode === MODE_CANDIDATES ? TCEACandidateVote : TCEAWinnerVote}
						hideAfterSubmit={this.state.mode === MODE_CANDIDATES}
						onSubmit={this.onSubmit.bind(this)}
						waiting={this.state.caseWait}
						data={{
							winners: winners,
							winnerCount: winners.length,
							nextDate: nextDate,
							refreshWinners: (e) => this.switchMode(e, MODE_WINNERS),
						}}
						path={API_URL + '/vote'}
					/>
				))}

			</div>
		);
	}

	onSubmit(res) {
		axios.post(API_URL + '/vote', qs.stringify(res))
		.then((res) => {
			if (this.state.mode === MODE_CANDIDATES) {
				this.state.winnerCount++;
			}
			this.fetchData();
		})
		.catch((res) => {
			this.fetchData();
		});
	}

	renderWaiting() {
		return (
			<div key='spinner' style={{ textAlign: 'center', width: '100%', marginTop: '50px' }}>
				<Spinner size='60' />
			</div>
		);
	}

	switchMode(e, mode) {
		e && e.preventDefault();

		const newState = {
			...this.state,
			mode: mode,
			caseWait: true,
		};

		this.updateData(mode, newState);
	}
}

export default connect(AccountJuryTCEA);

class TCEACandidateVote extends Component {
	static propTypes = {
		item: PropTypes.object.isRequired,
		path: PropTypes.string.isRequired,
		onSubmit: PropTypes.func.isRequired,
	};

	static defaultProps = {
		onSubmit: function (promise) {},
	};

	constructor(props) {
		super();

		this.state = {
			value: undefined,
		};
	}

	render() {
		let className = 'span14-tablet span14-mobile account-jury__entry__col3 account-jury__entry__votation';
		const { item, data } = this.props;

		let oneDayInMs = 86400000;
		let oneWeekInMs = 86400000 * 7;

		let today = new DateFormatter();
		let TCEADate = new DateFormatter(data.nextDate * 1000 || 'today');
		let firstAvailableTCEAWeek = TCEADate.week;

		let lastDateOfYear = new DateFormatter(today.year + '-12-29');
		let firstDateOfYear = new DateFormatter((today.year + 1) + '-01-04');
		let lastWeekOfYear = lastDateOfYear.week > firstDateOfYear.week ? lastDateOfYear.week : firstDateOfYear.week;
		if (lastWeekOfYear === 1) {
			lastWeekOfYear = 52;
		}

		let weekOptions = [];
		let maxWeek = Math.min(data.winnerCount || 0, lastWeekOfYear);
		let winners = data.winners;
		for (let i = 0; i <= maxWeek; i++) {
			let TCEADateCalc = TCEADate.week;

			for (let k = 0; k < winners.length; k++) {
				let usedWeek = (new DateFormatter(winners[k].week * 1000)).week;
				if (TCEADateCalc === usedWeek) {
					TCEADateCalc = false;
					break;
				}
			}

			if (TCEADateCalc) {
				weekOptions.push({
					label: `${TCEADate.dateMonthAndYear} - Week ${TCEADateCalc}`,
					value: TCEADateCalc,
				});

				firstAvailableTCEAWeek = TCEADateCalc;
			}

			TCEADate.addTime(oneWeekInMs);
		}

		return (
			<div className={className}>
				<Form getRefs={() => this.getRefs()} disableErrors method='post' action={this.props.path} onSubmit={this.onSubmit.bind(this)} disableAjaxSubmit>
					<InputText name='id' ref='id' type='hidden' value={item.id} />

					<div className='account-jury__entry__votation__top'>
						<div className='account-jury__entry__votation__top__switch'>
							<InputSwitch ref='vote' name='vote' on='Yes' off='No' value={this.state.value} onChange={this.onChangeVote.bind(this)} />

							{(!!this.state.value) && (
								<InputSelect ref='week' name='week' options={weekOptions} value={firstAvailableTCEAWeek} placeholder='When should it win?' className='account-jury__entry__votation__top__switch__select' />
							)}

							<div className='cf'></div>
						</div>
					</div>

					<div className='account-jury__entry__votation__bottom '>
						<div className='account-jury__entry__votation__comment'>
							<InputTextarea name='comments' ref='comments' placeholder='Any comments or messages for Rob?' className='account-jury__entry__votation__comment__textarea account-jury__entry__votation__comment__textarea--fill' span='span100p' />
							<div className='account-jury__entry__votation__comment__vote'>
								<div className='account-jury__entry__votation__comment__vote__flex'>
									<InputSubmit name='Submit your vote' value='Submit your vote' waiting={this.props.waiting} className='button--light' />
								</div>
							</div>
						</div>
					</div>
				</Form>
			</div>
		);
	}

	getRefs() {
		return this.refs;
	}

	onChangeVote(val) {
		this.setState({
			...this.state,
			value: val,
		});
	}

	onSubmit(promise) {
		this.setState({ ...this.state, waiting: true });
		this.props.onSubmit(
			new Promise((resolve, reject) => {
				promise.then((res) => {
					this.setState({ ...this.state, waiting: false });
					resolve(res);
				}).catch((res) => {
					this.setState({ ...this.state, waiting: false });
					reject(res);
				});
			})
		);
	}
}

class TCEAWinnerVote extends Component {
	static propTypes = {
		item: PropTypes.object.isRequired,
		path: PropTypes.string.isRequired,
		onSubmit: PropTypes.func.isRequired,
	};

	static defaultProps = {
		onSubmit: () => {},
	};

	constructor(props) {
		super();

		this.mounted = true;

		this.state = {
			value: undefined,
			waiting: false,
		};
	}

	componentWillUnmount() {
		this.mounted = false;
	}

	render() {
		let className = 'span14-tablet span14-mobile account-jury__entry__col3 account-jury__entry__votation relative';
		let { item, data } = this.props;

		let oneDayInMs = 86400000;
		let oneWeekInMs = 86400000 * 7;

		let today = new DateFormatter();
		let TCEADate = new DateFormatter(data.nextDate * 1000);

		let firstAvailableTCEAWeek = TCEADate.week;

		let lastDateOfYear = new DateFormatter(today.year + '-12-29');
		let firstDateOfYear = new DateFormatter((today.year + 1) + '-01-04');
		let lastWeekOfYear = lastDateOfYear.week > firstDateOfYear.week ? lastDateOfYear.week : firstDateOfYear.week;
		if (lastWeekOfYear === 1) {
			lastWeekOfYear = 52;
		}

		let weekOptions = [];
		let maxWeek = Math.min(this.props.data.winnerCount + 8 || 0, lastWeekOfYear);
		for (let i = 0; i < maxWeek; i++) {
			let TCEADateCalc = TCEADate.week;
			weekOptions.push({
				label: `${TCEADate.dateShortMonthAndYear} - Week ${TCEADateCalc}`,
				value: TCEADateCalc,
			});

			TCEADate.addTime(oneWeekInMs);
		}

		let caseWinValue = (new DateFormatter(item.week * 1000)).week;

		return (
			<div className={className}>
				<Form getRefs={() => this.getRefs()} disableErrors method='post' action={this.props.path} onSubmit={this.onSubmit.bind(this)} disableAjaxSubmit className='account-jury__entry__votation__tceawin__form'>
					<div className='account-jury__entry__votation__bottom account-jury__entry__votation__bottom--expanded'>
						<InputText name='id' ref='id' type='hidden' value={item.id} hideLabel />
						<InputText name='update' ref='update' type='hidden' value={1} hideLabel />

						<div className='account-jury__entry__votation__tceawin__top hide-tablet hide-mobile'>
							<div className='account-jury__entry__votation__tceawin__top__head'>TCEA Winner</div>

							<p className='span4 account-jury__entry__votation__tceawin__top__text'>This project will win TCEA in the week listed below. To change the week, select a new one in the dropdown and click “update”.</p>

							<div className='cf'></div>
						</div>

						<div className='account-jury__entry__votation__tceawin__bottom'>
							<InputSelect ref='week' name='week' options={weekOptions} placeholder='When should it win?' value={caseWinValue} className='span2 span4-tablet span12-mobile account-jury__entry__votation__tceawin__bottom__select' />

							<div className='account-jury__entry__votation__tceawin__bottom__vote'>
								<div className='account-jury__entry__votation__tceawin__bottom__vote__flex'>
									<InputSubmit name='Update' value='Update' waiting={(this.state.waiting || this.props.waiting)} className='button--light' />
								</div>
							</div>
						</div>
					</div>
				</Form>
			</div>
		);
	}

	getRefs() {
		return this.refs;
	}

	onChangeVote(val) {
		this.setState({
			...this.state,
			value: val,
		});
	}

	refreshWinners() {
		if (this.props.data && this.props.data.refreshWinners) {
			return this.props.data.refreshWinners();
		}

		return false;
	}

	onSubmit(promise) {
		this.setState({ ...this.state, waiting: true });
		this.props.onSubmit(
			new Promise((resolve, reject) => {
				promise.then((res) => {
					this.mounted && this.setState({ ...this.state, waiting: false });
					this.refreshWinners();
					resolve(res);
				}).catch((res) => {
					this.mounted && this.setState({ ...this.state, waiting: false });
					this.refreshWinners();
					reject(res);
				});
			})
		);
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/account/jury/tcea.js
 **/